export const mockArticleData = {
  title: "",
  short_text: "",
  text: "",
  status: 0,
  category_id: 0,
  lang: "AR",
  image: null,
};
